import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';

export default class Support extends lng.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      plinko: true,
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      SupportLogo: {
        y: 340,
        x: 475,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('/images/settings-icons/support-icon.svg'),
          79,
          119
        ),
      },
      SupportTitle: {
        y: 510,
        x: 415,
        w: 194,
        text: {
          text: 'Support',
          textColor: Colors('#fafafa').get(),
          textAlign: 'center',
          fontSize: 50,
        },
      },
      SupportLink: {
        x: 1050,
        y: 200,

        text: {
          text: 'For help visit us at',
          fontFace: 'OpenSans-SemiBold',
          textColor: Colors('#fafafa').get(),
        },
        fontSize: 35,
        Link: {
          x: 25,
          y: 75,
          text: {
            text: 'https://www.livingscriptures.com/support',
            textColor: Colors('#d6d6d6').get(),
            fontFace: 'OpenSans-Regular',
            fontSize: 35,
          },
        },
      },
      SupportContact: {
        text: {
          text: 'Contact us:',
          fontFace: 'OpenSans-SemiBold',
          textColor: Colors('#fafafa').get(),
        },
        x: 1050,
        y: 393,

        flex: { direction: 'column' },
        CallNumber: {
          y: 100,
          x: 25,
          text: { text: 'Call: 800-548-4647', fontFace: 'OpenSans-Regular' },
          color: Colors('#d6d6d6').get(),
          fontSize: 35,
        },
        Email: {
          y: 120,
          x: 25,
          text: { text: 'Email: cs@livingscriptures.com', fontFace: 'OpenSans-Regular' },
          color: Colors('#d6d6d6').get(),
          fontSize: 35,
        },
      },
    };
  }
}
